module.exports = __webpack_public_path__ + "static/media/CoolingFanpad.884ecd90.webp";